// =================================================================================================
// Mona Core API
// The version of the OpenAPI document: https://core.qa1.dev.cmona.de/auto-open-api-spec.yaml 1.9.0
// Contact: https://www.clinomic.biz
//
// NOTE: This class is auto generated at 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
// by OpenAPI Generator https://openapi-generator.tech
// Do not edit the class manually.
// =================================================================================================

import camelcaseKeys from 'camelcase-keys';
import { instanceToPlain, plainToInstance, Type, Transform } from 'class-transformer';
import snakecaseKeys, { SnakeCaseKeys } from 'snakecase-keys';
import { TransformDate } from '../helpers';

/**
 * Serializer for validating Practitioner web access login.
 * @see #/components/schemas/PractitionerLogInRequest - reference to schema in open-api-spec.yaml
 * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
 * @version 1.9.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator
 * Do not edit this manually.
 */
export interface PractitionerLogInRequest {
    /**
     * Practitioner Log In Username.
     *
     */
    username: string;
    /**
     * Practitioner Log In Password.
     *
     */
    password: string;
    /**
     * Device MAC address
     *
     */
    device_id?: string | null;
}
// -----------------------------------------------------------------------------
// Frontend Model
// NOTE: This class is auto generated by OpenAPI Generator
// Do not edit the class manually.
// -----------------------------------------------------------------------------

/**
 * Namespace that holds Frontend models/classes for PractitionerLogInRequest
 */
export namespace PractitionerLogInRequest {
    /**
     * PractitionerLogInRequest Frontend Model with camelCase properties
     * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
     * @version 1.9.0
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class Model {
        /**
         * Practitioner Log In Username.
         * @type string (`dataFormat` is missing)
         */
        username: string;
        /**
         * Practitioner Log In Password.
         * @type string (`dataFormat` is missing)
         */
        password: string;
        /**
         * Device MAC address
         * @type string (`dataFormat` is missing)
         */
        deviceId?: string | null;

        /** @hideconstructor */
        constructor(obj: Model) {
            Object.assign(this, camelcaseKeys(obj, { deep: true }));
        }
    }
    /**
     * PractitionerLogInRequest DTO
     * Transforms PractitionerLogInRequest model from/to API object
     * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
     * @version 1.9.0
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class DTO {
        /** Transforms to Frontend PractitionerLogInRequest model */
        static toModel(obj: PractitionerLogInRequest): Model {
            const newObj = camelcaseKeys(obj, { deep: true });
            return plainToInstance(Model, newObj);
        }
        /** Transforms to Backend PractitionerLogInRequest model */
        static toApi(obj: Model): PractitionerLogInRequest {
            const newObj = instanceToPlain(plainToInstance(Model, obj)) as PractitionerLogInRequest;
            return snakecaseKeys(newObj, { deep: true });
        }
    }
}
